define.alias("shared/components/shared/ui/report/settings-wrapper", "calendar/components/shared/ui/report/settings-wrapper");